import React from "react";
import {errorAlert, getWindowDimensions, hideHeader, successAlert} from "../../../actions/actionCreators";
import Grid from "@material-ui/core/Grid";
import NowrouzIllustration from "./Nowrouz.png";
import {connect} from "react-redux";
import {compose} from "redux";
import withStyles from "@material-ui/core/styles/withStyles";
import ButtonWithLoading from "../ButtonWithLoading";
import TextField from "@material-ui/core/TextField";
import agent from "../../../agent";
import i18n from "../../../i18nextInitiator";
import {withRouter} from "react-router-dom";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * JSS
 * @param theme
 * @return {{input: {"& input": {"&[type=number]": {"-moz-appearance": string, "-webkit-appearance": string}, "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {"-moz-appearance": string, margin: number, "-webkit-appearance": string}}}, root: {padding: string, backgroundColor: (string|string), position: string, zIndex: number}, box: {margin: string, "& > *": {margin: string}, maxWidth: number}}}
 */
const styles = (theme) => ({
    root: {
        padding: "0 20px 20px 20px",
        width: '100%',
        height: '100%',
        overflow: "auto",
        backgroundColor: theme.palette.primary.light,
    },
    box: {
        maxWidth:600,
        margin: "0 auto",
        '& > *': {
            margin: ".3rem 0",
            [theme.breakpoints.down("xs")] : {
                margin: ".1rem 0",
            }
        }
    },
    img: {
        width: 150
    }
});

const mapStateToProps = state => ({ ...state });

const mapDispatchToProps = dispatch => ({
    redirectToGame: ()=> {
        window.location = process.env.REACT_APP_NOWROUZ_GAME_URL
    }
});

class NowrouzReferral extends React.Component{
    constructor(props) {
        super(props);
        this.state = {};
        hideHeader()
    }

    /**
     * Gets called when referrer phone input is changed.
     * @param e
     */
    changeReferrerPhone = (e) => this.setState({referrerPhone: e.target.value})
    /**
     * Gets called when submit referrer button is clicked.
     * Submits the referrer phone by calling the backend api.
     */
    submitReferrer = () => {
        this.setState({submittingReferrer: true})
        agent.NowrouzGame.submitReferral({referrer_phone: this.state.referrerPhone})
            .then((res) => {
                if (res && res.message){
                    successAlert(res.message)
                    this.props.redirectToGame()
                }
            })
            .catch((res)=>{
                if (res.response && res.response.statusCode === 404){
                    errorAlert(t("error.wrong-phone"));
                }
                else{
                    const msg = (res.response && res.response.body && res.response.body.message) || t("error.connection")
                    errorAlert(msg)
                }
            })
            .finally(()=>this.setState({submittingReferrer: false}))
    }
    /**
     * Checks if the user have entered referral before or not.
     */
    checkReferral = () => {
        const score = window.localStorage.getItem('ngamebscore');
        if (this.props.auth.authenticated){
            agent.NowrouzGame.checkReferral()
                .then(res=>{
                    if (res && !res.registered_recently)
                        this.props.redirectToGame()
                    else if(!res.ability_to_insert_referral_record)
                        this.props.redirectToGame()
                })
            if (score){
                agent.NowrouzGame.setScore({score})
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.auth.authenticated !== this.props.auth.authenticated)
            this.checkReferral()

        if (prevState.referrerFromQueryString !== this.state.referrerFromQueryString)
            this.submitReferrer()
    }

    componentDidMount() {
        const q = new URLSearchParams(this.props.location.search)
        const referrerPhone = q.get("referrer")
        if (referrerPhone) {
            this.setState({referrerPhone, referrerFromQueryString: true})
        }
        this.checkReferral()
    }

    render() {

        const {
            props: {
                classes,
            },
            state: {
                referrerPhone
            } = {}
        } = this;

        const {height} = getWindowDimensions();

        return <Grid container className={classes.root} style={{height: height}}>
                    <Grid className={classes.box} container alignItems={"center"} direction={"column"}>

                        <Grid item>
                            <img style={{maxWidth: 600, width: "100%"}} src={NowrouzIllustration} alt={'logo'}/>
                        </Grid>

                        <br/>
                        <br/>
                        <TextField fullWidth variant={"outlined"}
                                   onChange={this.changeReferrerPhone}
                                   value={referrerPhone}
                                   name="referrer-phone"
                                   label={t("nowrouz-game.have-referrer")}
                                   placeholder={t("nowrouz-game.referrer-phone-placeholder")}
                        />

                        <ButtonWithLoading
                            action={this.submitReferrer}
                            disabled={!referrerPhone} color={"secondary"} text={t("nowrouz-game.referrer-btn-submit")}/>

                        <br/>
                        <br/>
                        <br/>

                        <ButtonWithLoading
                            action={()=> this.props.redirectToGame()}
                            text={t("nowrouz-game.skip")}/>

                    </Grid>
                </Grid>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter, withStyles(styles))(NowrouzReferral);